var map = {
	"./clock.svg": "duvA",
	"./cross.svg": "nRb8",
	"./door.svg": "dU1S",
	"./down.svg": "d94d",
	"./equals.svg": "yuL+",
	"./fourty.svg": "MHdh",
	"./lock.svg": "DThA",
	"./old.svg": "4QKh",
	"./plane.svg": "FnDY",
	"./poor.svg": "AzeM",
	"./temp.svg": "2WM8",
	"./vaccine.svg": "upyY"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ME8W";